/**
 * Required-field UX primitives.
 *
 *   <Required />            — small red * to put after the label text
 *   <RequiredLegend />      — "* fields are required" caption to put atop
 *                             a form so the marker is unambiguous
 *
 * Styles live in styles/index.css under `.required-mark` and `.required-legend`.
 */
import type { JSX } from 'react';

export function Required(): JSX.Element {
  return (
    <span className="required-mark" aria-label="required">
      *
    </span>
  );
}

export function RequiredLegend(): JSX.Element {
  return (
    <p className="required-legend">
      <span className="required-mark">*</span>fields marked with a red asterisk are required.
    </p>
  );
}
